//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/Model";
import { baseUrl } from '@/config';

class _BackofficeLocalizationClient {

  

  



  getBackofficeDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
  return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/BackofficeLocalization/GetBackofficeDictionary', {  }, showSpinner)
  }

  

  



  getAppDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
  return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/BackofficeLocalization/GetAppDictionary', {  }, showSpinner)
  }

  

  



    

    

    


  



  getAll(pagedRequestVM : OM.PagedRequestVM, showSpinner = true) : Promise<OM.PagedResponseOfLocalizedEntity> {
  return CommonServices.defaultPost<OM.PagedResponseOfLocalizedEntity>(baseUrl + 'api/BackofficeLocalization/GetAll', pagedRequestVM, { }, showSpinner)
  }
}
export let BackofficeLocalizationClient = new _BackofficeLocalizationClient();

class _ChallengeClient {

  

  



  getAllStages(showSpinner = true) : Promise<OM.StageVM[]> {
  return CommonServices.defaultGet<OM.StageVM[]>(baseUrl + 'api/Challenge/GetAllStages', {  }, showSpinner)
  }

  

  



    

    

    


  



  editStage(model : OM.StageVM, showSpinner = true) : Promise<string> {
  return CommonServices.defaultPost<string>(baseUrl + 'api/Challenge/EditStage', model, { }, showSpinner)
  }

  

  



    

    

    

      

    

    

    


  



  updateStageImage(stageIdentifier : string, file : File | string, progressFn: (prog) => void = null, showSpinner = true) : Promise<void> {
  return CommonServices.uploadFileToUrl<void>(baseUrl + 'api/Challenge/UpdateStageImage?stageIdentifier=' + stageIdentifier, file, { }, progressFn, showSpinner)
  }

  

  



    

    

    


  



  deleteStage(identifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Challenge/DeleteStage', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  getImagePath(stageIdentifier : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Challenge/GetImagePath', { stageIdentifier }, showSpinner)
  }

  

  



  getAllStagesInfo(showSpinner = true) : Promise<OM.StageVM[]> {
  return CommonServices.defaultGet<OM.StageVM[]>(baseUrl + 'api/Challenge/GetAllStagesInfo', {  }, showSpinner)
  }

  

  



    

    

    


  



  getById(stageIdentifier : string, showSpinner = true) : Promise<OM.StageVM> {
  return CommonServices.defaultGet<OM.StageVM>(baseUrl + 'api/Challenge/GetById', { stageIdentifier }, showSpinner)
  }
}
export let ChallengeClient = new _ChallengeClient();

class _GalleryItemClient {

  

  



    

    

    

      

    

    

    


  



  saveItemGallery(capturedOn : string, file : File | string, progressFn: (prog) => void = null, showSpinner = true) : Promise<string> {
  return CommonServices.uploadFileToUrl<string>(baseUrl + 'api/GalleryItem/SaveItemGallery?capturedOn=' + capturedOn, file, { }, progressFn, showSpinner)
  }

  

  



  getGallery(showSpinner = true) : Promise<OM.GalleryItemVM[]> {
  return CommonServices.defaultGet<OM.GalleryItemVM[]>(baseUrl + 'api/GalleryItem/GetGallery', {  }, showSpinner)
  }

  

  



    

    

    


  



  downloadImage(photoIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/GalleryItem/DownloadImage', { photoIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  shareImage(photoIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/GalleryItem/ShareImage', { photoIdentifier }, showSpinner)
  }
}
export let GalleryItemClient = new _GalleryItemClient();

class _GameClient {

  

  



  getUserGameResume(showSpinner = true) : Promise<OM.UserGameResume> {
  return CommonServices.defaultGet<OM.UserGameResume>(baseUrl + 'api/Game/GetUserGameResume', {  }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  



  stageCompleted(stageIdentifier : string, userIdentifier : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Game/StageCompleted', { stageIdentifier, userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  checkIfCanHaveGift(userIdentifier : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/Game/CheckIfCanHaveGift', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  setGiftTaken(gameIdentifier : string, showSpinner = true) : Promise<Date> {
  return CommonServices.defaultGet<Date>(baseUrl + 'api/Game/SetGiftTaken', { gameIdentifier }, showSpinner)
  }
}
export let GameClient = new _GameClient();

class _AdminClient {

  

  



  tokenUpgrade(showSpinner = true) : Promise<OM.InternalUserVM> {
  return CommonServices.defaultGet<OM.InternalUserVM>(baseUrl + 'api/Admin/TokenUpgrade', {  }, showSpinner)
  }

  

  



  dashboard(showSpinner = true) : Promise<OM.DashboardVM> {
  return CommonServices.defaultGet<OM.DashboardVM>(baseUrl + 'api/Admin/Dashboard', {  }, showSpinner)
  }

  

  



  fakeTextIdentifier(showSpinner = true) : Promise<OM.TextIdentifier> {
  return CommonServices.defaultGet<OM.TextIdentifier>(baseUrl + 'api/Admin/FakeTextIdentifier', {  }, showSpinner)
  }

  

  



  fakeAddress(showSpinner = true) : Promise<OM.Address> {
  return CommonServices.defaultGet<OM.Address>(baseUrl + 'api/Admin/FakeAddress', {  }, showSpinner)
  }

  

  



  getRankingStatus(showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/Admin/GetRankingStatus', {  }, showSpinner)
  }

  

  



  toggleRankingPublished(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ToggleRankingPublished', {  }, showSpinner)
  }

  

  



  getGalleryStatus(showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/Admin/GetGalleryStatus', {  }, showSpinner)
  }

  

  



  toggleGalleryPublished(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ToggleGalleryPublished', {  }, showSpinner)
  }

  

  



  getChallengeStatus(showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/Admin/GetChallengeStatus', {  }, showSpinner)
  }

  

  



  toggleChallengePublished(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ToggleChallengePublished', {  }, showSpinner)
  }

  

  



  getAppStatus(showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/Admin/GetAppStatus', {  }, showSpinner)
  }

  

  



  toggleAppPublished(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ToggleAppPublished', {  }, showSpinner)
  }

  

  



  getGadgetStatus(showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/Admin/GetGadgetStatus', {  }, showSpinner)
  }

  

  



  toggleGadgetPublished(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ToggleGadgetPublished', {  }, showSpinner)
  }

  

  



  getCountries(showSpinner = true) : Promise<OM.TextIdentifierVM[]> {
  return CommonServices.defaultGet<OM.TextIdentifierVM[]>(baseUrl + 'api/Admin/GetCountries', {  }, showSpinner)
  }

  

  



    

    

    


  



  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  refreshToken(tokens : OM.AuthResponse, showSpinner = true) : Promise<OM.AuthResponse> {
  return CommonServices.defaultPost<OM.AuthResponse>(baseUrl + 'api/Admin/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  resetPassword(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/Admin/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/Admin/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let AdminClient = new _AdminClient();

class _AppUserClient {

  

  



  tokenUpgrade(showSpinner = true) : Promise<OM.LoggedUserVM> {
  return CommonServices.defaultGet<OM.LoggedUserVM>(baseUrl + 'api/AppUser/TokenUpgrade', {  }, showSpinner)
  }

  

  



    

    

    


  



  changeLanguageAndGetToken(language : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/AppUser/ChangeLanguageAndGetToken', { language }, showSpinner)
  }

  

  



    

    

    


  



  checkIfAlreadyRegisterByEmail(email : string, showSpinner = true) : Promise<OM.AppUser> {
  return CommonServices.defaultGet<OM.AppUser>(baseUrl + 'api/AppUser/CheckIfAlreadyRegisterByEmail', { email }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  updateUserType(psw : string, identifier : string, type : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/UpdateUserType', { psw, identifier, type }, showSpinner)
  }

  

  



    

    

    


  



  getUserIdentifierBy(email : string, showSpinner = true) : Promise<string> {
  return CommonServices.defaultGet<string>(baseUrl + 'api/AppUser/GetUserIdentifierBy', { email }, showSpinner)
  }

  

  



    

    

    


  



  checkIfIsOwner(identifier : string, showSpinner = true) : Promise<boolean> {
  return CommonServices.defaultGet<boolean>(baseUrl + 'api/AppUser/CheckIfIsOwner', { identifier }, showSpinner)
  }

  

  



    

    

    


  



  updateUserInfo(model : OM.UpdateUserInfoVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/AppUser/UpdateUserInfo', model, { }, showSpinner)
  }

  

  



    

    

    


  



  setWristTaken(userIdentifier : string, showSpinner = true) : Promise<Date> {
  return CommonServices.defaultGet<Date>(baseUrl + 'api/AppUser/SetWristTaken', { userIdentifier }, showSpinner)
  }

  

  



    

    

    


  



  setWelcomeKitTaken(userIdentifier : string, showSpinner = true) : Promise<Date> {
  return CommonServices.defaultGet<Date>(baseUrl + 'api/AppUser/SetWelcomeKitTaken', { userIdentifier }, showSpinner)
  }

  

  



  getAllUsers(showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/GetAllUsers', {  }, showSpinner)
  }

  

  



    

    

    


  



  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/AppUser/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/AppUser/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  refreshToken(tokens : OM.AuthResponse, showSpinner = true) : Promise<OM.AuthResponse> {
  return CommonServices.defaultPost<OM.AuthResponse>(baseUrl + 'api/AppUser/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  resetPassword(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/AppUser/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/AppUser/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let AppUserClient = new _AppUserClient();

class _InternalUserClient {

  

  



  getAllInternalUser(showSpinner = true) : Promise<OM.InternalUserEditVM[]> {
  return CommonServices.defaultGet<OM.InternalUserEditVM[]>(baseUrl + 'api/InternalUser/GetAllInternalUser', {  }, showSpinner)
  }

  

  



    

    

    


  



  editInternalUser(model : OM.InternalUserEditVM, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/InternalUser/EditInternalUser', model, { }, showSpinner)
  }

  

  



    

    

    


  



  login(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/InternalUser/Login', model, { }, showSpinner)
  }

  

  



    

    

    


  



  register(model : OM.LanguageCredential, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultPost<OM.BaseApiLoginResponse>(baseUrl + 'api/InternalUser/Register', model, { }, showSpinner)
  }

  

  



    

    

    


  



  changePassword(newPassword : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/InternalUser/ChangePassword', { newPassword }, showSpinner)
  }

  

  



    

    

    


  



  resetConfirmationCode(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/InternalUser/ResetConfirmationCode', { username }, showSpinner)
  }

  

  



    

    

    


  



  refreshToken(tokens : OM.AuthResponse, showSpinner = true) : Promise<OM.AuthResponse> {
  return CommonServices.defaultPost<OM.AuthResponse>(baseUrl + 'api/InternalUser/RefreshToken', tokens, { }, showSpinner)
  }

  

  



    

    

    


  



  resetPassword(username : string, showSpinner = true) : Promise<void> {
  return CommonServices.defaultGet<void>(baseUrl + 'api/InternalUser/ResetPassword', { username }, showSpinner)
  }

  

  



    

    

    


  

    

    

    


  

    

    

    


  



  confirm(loginIdentifier : string, confirmationCode : string, preferredCulture : string, showSpinner = true) : Promise<OM.BaseApiLoginResponse> {
  return CommonServices.defaultGet<OM.BaseApiLoginResponse>(baseUrl + 'api/InternalUser/Confirm', { loginIdentifier, confirmationCode, preferredCulture }, showSpinner)
  }
}
export let InternalUserClient = new _InternalUserClient();

class _LocalizationClient {

  

  



  getAppDictionary(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
  return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAppDictionary', {  }, showSpinner)
  }

  

  



  getAll(showSpinner = true) : Promise<OM.LocalizedEntity[]> {
  return CommonServices.defaultGet<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAll', {  }, showSpinner)
  }

  

  



  getEnabledLanguages(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetEnabledLanguages', {  }, showSpinner)
  }

  

  



  getSupportedLanguages(showSpinner = true) : Promise<string[]> {
  return CommonServices.defaultGet<string[]>(baseUrl + 'api/Localization/GetSupportedLanguages', {  }, showSpinner)
  }

  

  



    

    

    


  



  saveLocalizedValue(item : OM.KeyValuePairOfStringAndString, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/SaveLocalizedValue', item, { }, showSpinner)
  }

  

  



    

    

    


  



  editLocalizedValue(value : OM.LocalizedEntity, showSpinner = true) : Promise<void> {
  return CommonServices.defaultPost<void>(baseUrl + 'api/Localization/EditLocalizedValue', value, { }, showSpinner)
  }
}
export let LocalizationClient = new _LocalizationClient();

interface FileParameter {
    data: any;
    fileName: string;
}

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}